var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-spin',{attrs:{"spinning":_vm.loading}},[_c('multistageTable',{ref:"tabelBox"})],1),_c('addOrgan',{attrs:{"resDataAdd":_vm.resDataAdd,"itemAdd":_vm.itemAdd,"item":_vm.item,"resData":_vm.resData,"visible":_vm.visible},on:{"close":_vm.close}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }